import { render, staticRenderFns } from "./RestaurantTimes.vue?vue&type=template&id=28a261ba&scoped=true"
import script from "./RestaurantTimes.vue?vue&type=script&lang=js"
export * from "./RestaurantTimes.vue?vue&type=script&lang=js"
import style0 from "./RestaurantTimes.vue?vue&type=style&index=0&id=28a261ba&prod&scoped=true&lang=css"
import style1 from "./RestaurantTimes.vue?vue&type=style&index=1&id=28a261ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a261ba",
  null
  
)

export default component.exports